import React from 'react';
import { SellerLevelOneBadge, SellerLevelTwoBadge, TopRatedBadge } from '@fiverr-private/badges';
import { Center } from '@fiverr-private/layout_components';
import { SellerLevel } from '../../gql-operations/gql-generated';
import { NewSellerLevelBadgeProps } from './types';

const MAP_SELLER_LEVEL_TO_BADGE = {
    [SellerLevel.LevelTrs]: TopRatedBadge,
    [SellerLevel.LevelOne]: SellerLevelOneBadge,
    [SellerLevel.LevelTwo]: SellerLevelTwoBadge,
};

export const hasNewSellerLevelBadge = (
    sellerLevel?: SellerLevel | null
): sellerLevel is keyof typeof MAP_SELLER_LEVEL_TO_BADGE => !!sellerLevel && !!MAP_SELLER_LEVEL_TO_BADGE[sellerLevel];

export const NewSellerLevelBadge = ({ sellerLevel }: NewSellerLevelBadgeProps) => {
    if (!hasNewSellerLevelBadge(sellerLevel)) {
        return null;
    }

    const LevelBadge = MAP_SELLER_LEVEL_TO_BADGE[sellerLevel];

    return (
        <Center aria-label="Seller Level Badge">
            <LevelBadge />
        </Center>
    );
};
